import React, { memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import DynamicSelect from "./DynamicSelectForLookup";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";

export default memo((props) => {
  const {
    value: initialValue,
    objectName,
    lookupConfig,
    fieldId,
    name,
    record,
    forwardedRef,
    onValueChange,
    stopEditing,
    api,
    fromGrid,
    lookupChanged,
  } = props;

  const [value, setValue] = useState(initialValue);
  const [lookupOptions, setLookupOptions] = useState({});
  const refContainer = useRef(null);

  useImperativeHandle(forwardedRef, () => ({
    getValue: () => value,
    isPopup: () => true,
    afterGuiAttached: () => {
      setTimeout(() => {
        refContainer.current?.focus();
      });
    }
  }));

  const handleChange = (selectedValue, option, recordObj) => {
    // If option.data exists, use it as the full object; otherwise fallback to selectedValue
    const newValue = recordObj;
    setValue(newValue);
    if (onValueChange) {
        onValueChange(newValue);
    }
    // Don't call stopEditing here, let Enter/Escape handle it
    if (fromGrid && lookupChanged) {
        const val = newValue ? { name: name + "_id", value: newValue } : null;
        lookupChanged(val, record?._id);
    }
  };

  const handleSearch = async (searchVal) => {
    if (!searchVal) {
      setLookupOptions((prev) => ({ ...prev, [name]: [] }));
      return;
    }
    try {
      const apiService = new ApiService(`${BASE_URL}/search_lookup/${fieldId}/${searchVal}`, {
        "Content-Type": "application/json"
      }, "POST", { child_context: record });
      const res = await apiService.makeCall();
      setLookupOptions((prev) => ({ ...prev, [name]: res }));
    } catch {
      setLookupOptions((prev) => ({ ...prev, [name]: [] }));
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        stopEditing && stopEditing();
      }
      if (event.key === "Enter") {
        stopEditing && stopEditing();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [stopEditing]);

  return (
    <div
      ref={refContainer}
      tabIndex={0}
      style={{ width: "100%" }}
    >
      <DynamicSelect
        objectName={objectName}
        lookupConfig={lookupConfig}
        onSearch={handleSearch}
        value={value}
        name={name}
        lookupOptionforparent={lookupOptions}
        fieldId={fieldId}
        onChange={handleChange}
      />
    </div>
  );
});